import React from "react";
import Form from "containers/Form";
import Field from "containers/Field/Field";
import { useModuleEnabled } from "playground/cms/Schema";
//import PropTypes from 'prop-types';

const fields = { tags: true };

export default function PageSettings({ type, id }) {
    //const {} = props;
    const hasProperties = useModuleEnabled("properties");
    return (
        <div className={"rows gap-md"}>
            {hasProperties && type !== "cms.properties" && (
                <>
                    <Field
                        id={"property"}
                        label={"Obiekt"}
                        fieldType={"select"}
                        nullable={true}
                        source={"api:cms.properties"}
                    />
                    <Field
                        id={"properties"}
                        label={"Obiekty"}
                        fieldType={"select"}
                        multiple={true}
                        nullable={true}
                        source={"api:cms.properties"}
                    />
                </>
            )}
            <Form type={type} id={id} selectFields={fields} />
            <Field
                id={"disable_critical_css"}
                label={"Wyłącz optymalizację critical css"}
                fieldType={"checkbox"}
            />
            <Field id={"description"} label={"Opis"} />
        </div>
    );
}

PageSettings.propTypes = {};
PageSettings.defaultProps = {};
